// extracted by mini-css-extract-plugin
export default {"optionalMessage":"OptionalMessage__optionalMessage___3DUO5"};